module.exports = __webpack_public_path__ + "static/media/ex19.2b7ae393.jpg";